import {
  USER_ROL_COMERCIAL,
  USER_ROL_SUPERADMIN,
  User,
  UserPermiso,
} from '../models/user.model';

function getPermiso(user: User | null | undefined, seccion: number): UserPermiso | undefined {
  return user?.permisos?.find((permiso) => permiso.seccion === seccion);
}

export function isSuperAdminUser(user: User | null | undefined): boolean {
  return (user?.rol ?? 0) === USER_ROL_SUPERADMIN;
}

export function isComercialUser(user: User | null | undefined): boolean {
  return (user?.rol ?? 0) === USER_ROL_COMERCIAL;
}

export function canUserView(user: User | null | undefined, seccion: number): boolean {
  if (!user) {
    return false;
  }

  if (isSuperAdminUser(user)) {
    return true;
  }

  return !!getPermiso(user, seccion)?.view;
}

export function canUserEdit(user: User | null | undefined, seccion: number): boolean {
  if (!user) {
    return false;
  }

  if (isSuperAdminUser(user)) {
    return true;
  }

  return !!getPermiso(user, seccion)?.edit;
}

export function canUserDelete(user: User | null | undefined, seccion: number): boolean {
  if (!user) {
    return false;
  }

  if (isSuperAdminUser(user)) {
    return true;
  }

  return !!getPermiso(user, seccion)?.delete;
}

export function canUserAccessOpcionesAdmin(user: User | null | undefined): boolean {
  return isSuperAdminUser(user);
}
